export function getMexicanDatetime(datetime: Date | string = new Date(), locale = 'en-US'): string {
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'America/Mexico_city',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };
  const formatter = new Intl.DateTimeFormat(locale, options);

  return formatter.format(new Date(datetime));
}

export function getMexicanSqlDate(datetime: Date | string) {
  const nowInMexico = getMexicanDatetime(datetime, 'en-US');
  const nowInMexicoArray = nowInMexico.substr(0, 10).split('/');
  return nowInMexicoArray[2] + '-' + nowInMexicoArray[0] + '-' + nowInMexicoArray[1];
}

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Formatea una fecha de la API como dd/MM/yyyy en la zona en que corre la API.
 *
 * Las fechas de vigencia se guardan a las 23:59:59 hora de México y la API las serializa
 * en UTC ("2026-12-01T05:59:59Z" = 30/11/2026 en México), así que interpretarlas en la
 * zona del dispositivo —o recortar el string ISO— recorre la fecha un día.
 */
export function formatMexicanDate(datetime: Date | string): string {
  // Un string solo-fecha ("2026-07-15", p.ej. realtrips.date) no trae hora que convertir,
  // y JS lo parsearía como medianoche UTC, que en México cae el día anterior.
  if (typeof datetime === 'string' && DATE_ONLY.test(datetime)) {
    const [year, month, day] = datetime.split('-');
    return `${day}/${month}/${year}`;
  }
  const [year, month, day] = getMexicanSqlDate(datetime).split('-');
  return `${day}/${month}/${year}`;
}

export function formatSqlDate(datetime: Date | string | number, withTime = false) {
  const date = new Date(datetime);
  const year = date.getFullYear();

  let month = '' + (date.getMonth() + 1),
    day = '' + date.getDate();
  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }
  const time = withTime ? ' ' + date.toTimeString().split(' ')[0] : '';
  return [year, month, day].join('-') + time;
}
